import { BreakpointObserver } from "@angular/cdk/layout";
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ScreenBreakpoint {
    constructor(
        private breakpointObserver: BreakpointObserver
    ) { }
    checkScreenBreakpoint(mediaQuery: string) {
        // console.log('media', this.breakpointObserver.isMatched(mediaQuery))
        return this.breakpointObserver.isMatched(mediaQuery);
    }
}
